<div class="ts-tabs-panel">
    <ul class="ts-tabs-list" role="tablist">
        <li tabindex="0" (click)="onSelectTab(tab.id)" (keydown.enter)="onSelectTab(tab.id)" role="tab" *ngFor="let tab of tabs"
            [ngClass]="((tab.id === selectedTab )? 'active-tab' : '')" class="ts-tab-item"  [attr.aria-selected]="tab.id === selectedTab">
            <span class="tab-title">{{ tab.title }}</span>
        </li>
    </ul>
</div>